import {
  Box,
  Heading,
  VStack,
  Text,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";

import PublicLayout from "./Layouts/PublicLayout";

import { useNavigate } from "react-router-dom";

import {
  useState,
  useCallback,
  useEffect,
} from "react";

import { useLocation } from "react-router-dom";

import {
  OfferFullDetails,
} from "../../Platform/Common/types";

import axios from "axios";

import bandpic from "../../resources/EDUVIC B2C Hero3.png";

import FreeOfferCard from "../Components/FreeOfferCard"; 

const B2CFreeResources = () => {

  const navigate = useNavigate();

  const [offerFullDetails, setOfferFullDetails] = useState<
    OfferFullDetails[]
  >([]);

  // =========================
  // FETCH FREE OFFERS
  // =========================

  const fetchFreeOffers = useCallback(async () => {

    try {

      const apiUrl =
        process.env.REACT_APP_API_URL ||
        "https://default-url.com";

      const response = await axios.get(
        `${apiUrl}/b2c/public/free-offers`
      );

      setOfferFullDetails(response.data);

    } catch (error) {

      console.error(
        "Failed to load Free Offers",
        error
      );
    }

  }, []);

  // =========================
  // INITIAL LOAD
  // =========================

  useEffect(() => {

    fetchFreeOffers();

  }, [fetchFreeOffers]);

  // =========================
  // SEO
  // =========================

  useEffect(() => {

    document.title =
      "Free Online Practice Tests | Eduvic";

    const meta = document.querySelector(
      "meta[name='description']"
    );

    if (meta) {

      meta.setAttribute(
        "content",
        "Free online practice tests for NAPLAN, Selective Entry, Scholarship and school assessments."
      );
    }

  }, []);

  // =========================
  // HASH NAVIGATION
  // =========================

  const { hash, pathname } = useLocation();

  useEffect(() => {

    if (hash) {

      const element = document.querySelector(hash);

      if (element) {

        const yOffset = -80;

        const yPosition =
          element.getBoundingClientRect().top +
          window.scrollY +
          yOffset;

        window.scrollTo({
          top: yPosition,
          behavior: "smooth",
        });

        return;
      }
    }

    window.scrollTo(0, 0);

  }, [pathname, hash]);

  return (

    <PublicLayout>

      <Box>

      {/* ================= HERO ================= */}

      <Box
        as="section"
        minH={{ base: "260px", md: "320px" }}
        bgImage={bandpic}
        bgSize="cover"
        // Mobile crops from the left side of the source image instead of
        // the right, so the logo/figure moves out of the text's way.
        // Desktop/tablet unchanged.
        bgPosition={{ base: "left center", md: "right center" }}
        bgRepeat="no-repeat"
        position="relative"
        overflow="hidden"
      >
        {/* LEFT Gradient Overlay for readability */}
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          bgGradient="
            linear(
              to-r,
              rgba(0,0,0,0.68),
              rgba(0,0,0,0.35),
              rgba(0,0,0,0)
            )
          "
          zIndex={1}
        />

        {/* Content */}
        <Box
          position="relative"
          zIndex={2}
          minH={{ base: "260px", md: "320px" }}
          display="flex"
          alignItems="center"
          px={{ base: 6, md: 16 }}
        >
          <VStack
            align="flex-start"
            spacing={4}
            maxW="700px"
          >

            <Heading
              color="white"
              size="2xl"
              lineHeight="1.2"
            >
              Free Eduvic Resources
            </Heading>

            <Text
              color="gray.100"
              fontSize={{ base: "md", md: "lg" }}
              lineHeight="1.7"
              maxW="650px"
            >
              Explore free exam-style practice tests across NAPLAN,
              Selective Entry, Scholarship, and other school assessments.
            </Text>

          </VStack>
        </Box>
      </Box>

        {/* FREE OFFERS */}

        {offerFullDetails.length > 0 && (

          <Box py={12} px={6}>

            <VStack spacing={10}>

              <VStack spacing={3}>

                <Heading size="xl">
                  Free Practice Tests
                </Heading>

                <Text
                  color="gray.500"
                  textAlign="center"
                  maxW="2xl"
                >
                  Start practising with free tests
                  designed to build confidence,
                  familiarity, and exam readiness.
                </Text>

              </VStack>

              <SimpleGrid
                columns={{
                  base: 1,
                  md: 2,
                  lg: 3,
                }}
                spacing={8}
                maxW="1200px"
                mx="auto"
                width="100%"
              >

                {offerFullDetails.map((offer) => (

                  <FreeOfferCard
                    key={offer.offer_id}
                    offer={offer}
                    domainSlug={offer.domain_slug}
                  />

                ))}

              </SimpleGrid>

            </VStack>

          </Box>

        )}

      </Box>

    </PublicLayout>
  );
};

export default B2CFreeResources;